//libs
import * as yup from "yup";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
//components
import Button from "components/Button";
import Message from "components/Message";
import TextField from "components/Fields";
import SlimLayout from "components/SlimLayout";
import Loading from "components/Loading";
//hooks
import { useLogin } from "hooks/api/useLogin";
import { yupResolver } from "@hookform/resolvers/yup";

export const metadata = {
  title: "Sign In",
};

const schema = yup.object({
  email: yup
    .string()
    .email("Email must a valid format")
    .required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
});

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { isLoading, login } = useLogin();

  const onSubmit = (values) => {
    login({ email: values.email, password: values.password });
  };

  return (
    <div className="absolute bg-white top-0 right-0 bottom-0 left-0 z-50 grid grid-cols-1 lg:grid-cols-2 items-center">
      <div className="mt-10 max-w-96 mx-auto">
        <div className="mb-8">
          <h1 className="text-black text-2xl font-bold">Welcome back</h1>
          <p>Welcome back! Please enter your details.</p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-y-4">
          <div>
            <TextField
              label="Email address"
              name="email"
              type="text"
              autoComplete="off"
              {...register("email")}
            />
            <Message message={errors.email?.message} />
          </div>
          <div>
            <TextField
              label="Password"
              name="password"
              type="password"
              {...register("password")}
              autoComplete="off"
            />
            <Message message={errors.password?.message} />
          </div>
          <div>
            <Button
              type="submit"
              variant="solid"
              className="w-full"
              disabled={isLoading || !isValid}
            >
              <Loading text="Submit" isLoading={isLoading} />
            </Button>
          </div>
        </form>
        <p className="mt-4">Don't have an account? <Link to='/pricing' className="text-blue-500 font-bold">Sign Up</Link></p>
      </div>
      <div className="rounded-l-4xl overflow-hidden hidden lg:block">
        <img src="login-cover.jpg" alt="Login" className="max-w-full" />
      </div>
    </div>
  );
}
